import React from 'react';

import { AlineTooltip, ToolbarButton } from 'src/components';
import { DecreaseFontSizeIcon } from 'src/components/icons/DecreaseFontSizeIcon';
import { IncreaseFontSizeIcon } from 'src/components/icons/IncreaseFontSizeIcon';
import { useEditorTabStateSelector } from 'src/editor/editor-tab-state-registry';
import { useCurrentUserId } from 'src/gql';
import { useAuthorizedTransforms } from 'src/hooks';
import { useEditor, useEditorLoading } from 'src/layout-engine';
import { makeStyles } from 'tss-react/mui';

import { ClientTransforms } from '../../../transforms';

const useStyles = makeStyles()({
  button: {
    height: 32,
    margin: '0px 2px 0px 2px',
    width: 32,
  },
  wrapper: {
    display: 'flex',
  },
});

export const TextSizeButtons = React.memo(function TextSizeButtons(): JSX.Element {
  const { classes } = useStyles();
  const editor = useEditor();
  const editorLoading = useEditorLoading();
  const { AuthorizedTransforms } = useAuthorizedTransforms();

  const editingMode = useEditorTabStateSelector(state => state.documentUi.editingMode);
  const currentUserId = useCurrentUserId();

  function incrementFontSize(): void {
    if (!currentUserId || !editingMode) return;

    AuthorizedTransforms.incrementFontSize(editor, { authorId: currentUserId, editingMode });
    ClientTransforms.focus(editor);
  }

  function decrementFontSize(): void {
    if (!currentUserId || !editingMode) return;

    AuthorizedTransforms.decrementFontSize(editor, { authorId: currentUserId, editingMode });
    ClientTransforms.focus(editor);
  }

  return (
    <div className={classes.wrapper}>
      <AlineTooltip arrow placement="bottom" title="Increment font size">
        <div>
          <ToolbarButton
            className={classes.button}
            disabled={editorLoading}
            onClick={incrementFontSize}
          >
            <IncreaseFontSizeIcon />
          </ToolbarButton>
        </div>
      </AlineTooltip>
      <AlineTooltip arrow placement="bottom" title="Decrement font size">
        <div>
          <ToolbarButton
            className={classes.button}
            disabled={editorLoading}
            onClick={decrementFontSize}
          >
            <DecreaseFontSizeIcon />
          </ToolbarButton>
        </div>
      </AlineTooltip>
    </div>
  );
});
